module.exports = __webpack_public_path__ + "static/app-store-icon-e3d12cfe3d8a1b28493f3ecb13366e70.png";